

const infoContainers = document.querySelectorAll('.info-container');
const infoContainerArray = Array.from(infoContainers);
const activeContainer = infoContainerArray[0];
const activeContainerInfoBox = activeContainer.querySelector('.info-box');

const openers = document.querySelectorAll('.info-container .info-open');
const closers = document.querySelectorAll('.info-container .info-close .icon--close');

//add active class to first cog
activeContainer.classList.add('active');

//add event listener to each cog
openers.forEach(opener => {
    opener.addEventListener('click', openInfo);
});


//add event listener to each cross
closers.forEach(closer => {
    closer.addEventListener('click', closeInfo);
});


//opens the popups on opener click
function openInfo(event) {
    const cogs = document.querySelectorAll('.info-container');
    cogs.forEach((cog) => {
        cog.classList.remove('active');
    })
    const infoContainer = event.target.closest('.info-container');
    const triangleAndBox = infoContainer.querySelector('.triangle-and-box');
    const infoBox = triangleAndBox.querySelector('.info-box');
    if (triangleAndBox) {
        infoContainer.classList.toggle('active');
        handleDropdownPosition(infoBox);
    }
    requestAnimationFrame(() => {
        document.addEventListener('click', closeOnPageClick);
    })
}


//close popup on cross click
function closeInfo(event) {
    const infoContainer = event.target.closest('.info-container');
    const triangleAndBox = infoContainer.querySelector('.triangle-and-box');
    if (triangleAndBox) {
        infoContainer.classList.remove('active');
    }
    document.removeEventListener('click', closeOnPageClick);
}



//close popup on page click
function closeOnPageClick(event) {
    if (event.target.closest('.info-open')) {
        return; // If it is, don't proceed with closing the popup
    }
    infoContainerArray.forEach(infoContainer => {
        const triangleAndBox = infoContainer.querySelector('.triangle-and-box');
        if (!triangleAndBox?.contains(event.target) && infoContainer.classList.contains('active')) {
            infoContainer.classList.remove('active');
            document.removeEventListener('click', closeOnPageClick);
        }
    });
}



window.onload = function () {
    handleDropdownPosition(activeContainerInfoBox);
};


function handleDropdownPosition(infoBox) {

    const dropdownRect = infoBox.getBoundingClientRect();

    const dropdownRightX = dropdownRect.x + dropdownRect.width;
    const overflow = dropdownRightX - window.innerWidth;

    if (dropdownRect.x < 0) {
        infoBox.style.left = '3%';
        infoBox.style.right = 'auto';
    } else if (overflow >= 0) {
        const translationX = overflow + 10;

        infoBox.style.left = 'auto';
        infoBox.style.right = `${translationX}px`;
    }
}
